import { GET_PAYROLL_BREAKDOWN } from "../../graphql/timesheet";
import { buildPayrollBreakdown, buildTimesheet, buildUser, buildWorkerInfo } from "../factories";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { MockedProvider } from "@apollo/client/testing/react";
import React, { useMemo } from "react";
import { ProfileType, TimeSheetState } from "../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { navigatorLogger } from "../navigator-mock";
import PayrollBreakdownTimeSheetScreen from "../../screens/user/PayrollBreakdownTimeSheetScreen";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

const MOCKS = [
    {
        request: {
            query: GET_PAYROLL_BREAKDOWN,
            variables: {
                payrollBreakdownId: "001",
            },
        },
        result: () => ({
            data: {
                getPayrollBreakdown: buildPayrollBreakdown(new Date(2024, 1, 1), {
                    timesheets: [
                        buildTimesheet({
                            status: TimeSheetState.Open,
                        }),
                        buildTimesheet({
                            status: TimeSheetState.Submitted,
                        }),
                        buildTimesheet({
                            status: TimeSheetState.Accepted,
                        }),
                        buildTimesheet({
                            status: TimeSheetState.Rejected,
                        }),
                    ],
                }),
            },
        }),
    },
];
const StoryComponent = ({ profileType }: { profileType: ProfileType }) => {
    const user = useMemo(
        () =>
            buildUser({
                workerInfo: buildWorkerInfo(),
            }),
        [],
    );

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={profileType}>
                <MockedProvider mocks={MOCKS}>
                    <PayrollBreakdownTimeSheetScreen
                        /* @ts-expect-error Stack Component need a complex navigation handler */
                        route={{ params: { payrollBreakdownId: "001" } }}
                        /* @ts-expect-error Stack Component need a complex navigation handler */
                        navigation={navigatorLogger}
                    />
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/PayrollBreakdown Timesheet",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Client: Story = {
    args: {
        profileType: ProfileType.Client,
    },
};
export const Worker: Story = {
    args: {
        profileType: ProfileType.Worker,
    },
};
